import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Layout from './AppLayout';

import interceptor from '../service/_base/interceptor';
import Auth from '../pages/Auth/Index';
import Portal from '../pages/Portal/Index';
import './styles.css';


export default class App extends React.Component {
    render() {
        interceptor.init();
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path="/auth" component={Auth} />
                    <Route exact path="/portal" component={Portal} />
                    <Layout />
                </Switch>
            </BrowserRouter>
        );
    }
}